<template>
  <app-layout>
    <v-layout column wrap>
      <v-flex xs12>
        <v-alert
          v-if="getUser.subscription_data && getUser.subscription_data.manual_payment"
          :value="true"
          type="warning"
        >
          {{ $t('manualSubscriptionUntil', {date: dashToDotsDateFormat(getUser.subscription_data.manual_payment_ends_at)}) }}
        </v-alert>
      </v-flex>
      <v-flex xs12>
        <v-stepper v-model="currentStep">
          <v-stepper-header>
            <template v-for="(step, index) in steps">
              <v-stepper-step
                :complete="currentStep > index"
                :step="index+1"
                :key="`${index}-step`"
              >
                {{ step }}
              </v-stepper-step>
              <v-divider :key="`${index}-divider`"/>
            </template>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content
              step="1"
              class="pa-0"
            >
              <subscription-plans
                @next="next"
                @planChanged="paymentPlan => stripeData.paymentPlan = paymentPlan"
              />
            </v-stepper-content>

            <v-stepper-content
              step="2"
              class="pa-0"
            >
              <subscription-payment-method
                ref="subscriptionPayment"
                :is-loading="isLoading"
                @stripeTokenGenerated="token => stripeData.token = token"
                @next="next"
                @prev="prev"
                @loading="val => isLoading = val"
              />
            </v-stepper-content>

            <v-stepper-content
              step="3"
              class="pa-0"
            >
              <subscription-checkout
                v-bind="{stripeData, isLoading}"
                @complete="checkout"
                @prev="prev"
              />
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-flex>

    </v-layout>

  </app-layout>
</template>

<script>
import SubscriptionApi from '@/api/AgentApi'
import SubscriptionPlans from './SubscriptionPlans'
import SubscriptionPaymentMethod from './SubscriptionPaymentMethod'
import SubscriptionCheckout from './SubscriptionCheckout'
import { dashToDotsDateFormat } from '@/utils/customFormatters'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Subscription',
  props: ['contractId'],
  components: {
    SubscriptionCheckout,
    SubscriptionPaymentMethod,
    SubscriptionPlans
  },
  data () {
    return {
      isLoading: false,
      currentStep: 0,
      steps: [
        this.$t('planStep'),
        this.$t('paymentType'),
        this.$t('checkout')
      ],
      stripe: null,
      stripeData: {
        paymentPlan: {},
        token: null
      }
    }
  },
  computed: {
    ...mapGetters('user', ['getUser'])

  },
  methods: {
    ...mapActions({
      setPaymentPlans: 'paymentPlans/setPaymentPlans'
    }),
    dashToDotsDateFormat,
    async checkout () {
      this.isLoading = true
      try {

        const result = await SubscriptionApi.subscribe(this.contractId, {
          stripe_token: this.stripeData.token.id,
          plan: this.stripeData.paymentPlan.alias
        })

        this.$notification({success: {message: ['Zahlungsdaten erfolgreich gespeichert']}})
        this.$router.push({ name: 'agentContracts' })
      } catch (e) {
        this.$notification(e)
      }
      this.isLoading = false
    },
    next () {
      this.currentStep++
    },
    prev () {
      this.currentStep--
    }
  },
  created () {
    this.setPaymentPlans()
  },
  i18n: {
    messages: {
      de: {
        planStep: 'Ihr Paket',
        paymentType: 'Bezahlart',
        checkout: 'Abschluss',
        manualSubscriptionUntil: 'Ihr Abonnement endet am {date}'
      },
      en: {
        planStep: 'Selected Package',
        paymentType: 'Payment',
        checkout: 'Checkout',
        manualSubscriptionUntil: 'Your manual subscription ends at {date}'
      },
      tr: {
        planStep: 'Seçilen paket',
        paymentType: 'Ödeme',
        checkout: 'Ödeme',
        manualSubscriptionUntil: 'Manuel üyeliğinizin bitiş tarihi {date}'
      },
      ru: {
        planStep: 'Выбранный план',
        paymentType: 'Тип платежа',
        checkout: 'Оплата',
        manualSubscriptionUntil: 'Ваша ручная подписка активна до {date} '
      }
    }
  }
}
</script>
